import { Checkbox } from "@/components/ui/checkbox";

export const SECTIONS = [
  { key: "calendar", label: "Calendario" },
  { key: "bookings", label: "Prenotazioni" },
  { key: "guests", label: "Ospiti" },
  { key: "rooms", label: "Camere" },
  { key: "cleaning", label: "Pulizie" },
  { key: "exports", label: "Schedine & ISTAT" },
  { key: "invoices", label: "Fatture & Ricevute" },
  { key: "reports", label: "Report Incassi" },
  { key: "auditorium", label: "Calendario Auditorium" },
  { key: "mensa", label: "Mensa" },
];

export const canSee = (user, section) => !section || user?.role === "admin" || (user?.sections || []).includes(section);

export const PERMISSION_PRESETS = [
  { key: "reception", name: "Solo reception", sections: ["calendar", "bookings", "guests", "rooms", "cleaning"] },
  { key: "reception_invoices", name: "Reception + fatture", sections: ["calendar", "bookings", "guests", "rooms", "cleaning", "invoices"] },
  { key: "housekeeping", name: "Solo pulizie", sections: ["cleaning", "rooms"] },
  { key: "backoffice", name: "Back office", sections: ["bookings", "guests", "exports", "invoices", "reports"] },
  { key: "full", name: "Tutto", sections: SECTIONS.map((s) => s.key) },
];

export const SectionPicker = ({ value, onChange, testPrefix = "perm" }) => {
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  const same = (a, b) => a.length === b.length && a.every((x) => b.includes(x));
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-1.5" data-testid={`${testPrefix}-presets`}>
        {PERMISSION_PRESETS.map((p) => (
          <button key={p.key} type="button" data-testid={`${testPrefix}-preset-${p.key}`} onClick={() => onChange(p.sections)}
            className={`text-xs rounded-full px-3 py-1 border transition-colors ${same(value, p.sections) ? "bg-accent text-accent-foreground border-accent" : "border-border hover:bg-secondary"}`}>{p.name}</button>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-2" data-testid={`${testPrefix}-list`}>
        {SECTIONS.map((sec) => (
          <label key={sec.key} className={`flex items-center gap-2 rounded-md border px-3 py-2 text-sm cursor-pointer ${value.includes(sec.key) ? "border-accent bg-accent/10" : "border-border"}`}>
            <Checkbox data-testid={`${testPrefix}-${sec.key}`} checked={value.includes(sec.key)} onCheckedChange={() => toggle(sec.key)} />{sec.label}
          </label>
        ))}
      </div>
    </div>
  );
};
